import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form } from '@/components/ui/form';
import { FileUploadField } from '@/modules/common/components/organisms/file-upload-field';

import { TimeOffRequestAttachment } from '../../types/time-off-request-details';

interface AttachmentItemProps {
  attachment: TimeOffRequestAttachment;
}

const AttachmentItem = ({ attachment }: AttachmentItemProps) => {
  const { t } = useTranslation('authenticated.timeOff');
  const form = useForm<{ file: null }>({ defaultValues: { file: null } });

  return (
    <Form {...form}>
      <FileUploadField
        control={form.control}
        name="file"
        helpText={t('details.attachment.helpText')}
        config={{
          queryKey: ['time-off-attachment-display', attachment.id],
          fileUrl: attachment.url,
          allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
          maxSize: 10 * 1024 * 1024,
          accept: 'image/jpeg,image/png,image/jpg,application/pdf',
        }}
        disabled
      />
    </Form>
  );
};

interface TimeOffRequestAttachmentSectionProps {
  attachments: TimeOffRequestAttachment[];
}

export const TimeOffRequestAttachmentSection = ({
  attachments,
}: TimeOffRequestAttachmentSectionProps) => {
  const { t } = useTranslation('authenticated.timeOff');

  if (attachments.length === 0) {
    return <p className="text-sm text-muted-foreground">{t('details.attachment.none')}</p>;
  }

  return (
    <div className="flex flex-col gap-2">
      {attachments.map(attachment => (
        <AttachmentItem key={attachment.id} attachment={attachment} />
      ))}
    </div>
  );
};
